import React, { useState } from 'react';
import { Key, AlertCircle } from 'lucide-react';
import { verifyMfaToken } from '../services/api';

export default function MfaLogin({ email, onSuccess, onCancel }) {
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token.trim() || token.length !== 6) {
      setError('Enter the 6-digit code');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await verifyMfaToken(email, token.trim());
      if (result.success) {
        onSuccess(result.accessToken, result.rep);
      } else {
        setError(result.error || 'Invalid code');
      }
    } catch (err) {
      // MFA login error handled silently
      setError('Invalid code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 space-y-4">
        <div className="flex items-center gap-2">
          <Key className="text-primary-900" size={24} />
          <h2 className="text-xl font-bold text-primary-900">Enter MFA Code</h2>
        </div>
        <p className="text-sm text-gray-600">
          Open your authenticator app and enter the 6-digit code for <strong>{email}</strong>.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Code</label>
            <input
              type="text"
              maxLength={6}
              value={token}
              onChange={(e) => setToken(e.target.value.replace(/\D/g, ''))}
              placeholder="000000"
              className="w-full border rounded px-3 py-2 text-center text-lg tracking-widest focus:outline-none focus:ring-2 focus:ring-primary-900"
              autoFocus
            />
          </div>
          {error && (
            <div className="flex items-center gap-1 text-red-600 text-xs">
              <AlertCircle size={12} />
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading || token.length !== 6}
            className="w-full bg-primary-900 text-white py-2 rounded-lg hover:bg-primary-800 transition disabled:opacity-50"
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full text-sm text-gray-500 hover:text-gray-700 transition"
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}
